@use '../../style/reset.scss';
@use '../../style/functions.scss';
@use '../../style/typography.scss';

:host {
    display: block;
}

pre,
code {
    font-family: var(--kompendium-font-code);
    border-radius: functions.pxToRem(4);
    font-size: functions.pxToRem(11);

    a {
        font-size: functions.pxToRem(11);
    }
}

code {
    background: rgba(var(--kompendium-contrast-1100), 0.05);
    border: 1px solid rgba(var(--kompendium-contrast-1100), 0.1);
    padding: 0.125rem 0.3125rem;
    margin: 0 0.125rem;
    white-space: pre-wrap;
    color: rgb(var(--kompendium-contrast-1100));
}

pre {
    > code {
        display: block;
        padding: 0.625rem 0.6375rem;
        white-space: pre-wrap;
    }
}

.value--false {
    code {
        color: rgb(var(--kompendium-color-code-magenta));
        border-color: rgba(var(--kompendium-color-code-magenta), 0.2);
        background-color: rgba(var(--kompendium-color-code-magenta), 0.1);
    }
}

.value--true {
    code {
        color: rgb(var(--kompendium-color-code-green-dark));
        border-color: rgba(var(--kompendium-color-code-green-dark), 0.2);
        background-color: rgba(var(--kompendium-color-code-green-dark), 0.1);
    }
}

dl {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-template-rows: 1fr;
    margin-bottom: 2rem;
    border: 1px solid rgb(var(--kompendium-contrast-500));
    border-radius: functions.pxToRem(6);
    background-color: rgb(var(--kompendium-contrast-300));

    dt,
    dd {
        padding: functions.pxToRem(6) functions.pxToRem(8);
        font-size: functions.pxToRem(14);

        &:nth-of-type(even) {
            background-color: rgb(var(--kompendium-contrast-400));
        }
    }
    dt {
        &:first-child {
            border-top-left-radius: functions.pxToRem(6);
        }
        &:last-child {
            border-bottom-left-radius: functions.pxToRem(6);
        }
    }
    dd {
        &:first-child {
            border-top-right-radius: functions.pxToRem(6);
        }
        &:last-child {
            border-bottom-right-radius: functions.pxToRem(6);
        }
    }
}

dl,
dt,
dd {
    transition:
        background-color 0.3s ease 0.05s,
        border-color 0.3s ease 0.05s;
}
